export type MobileHeroBanner = {
  id: number | string;
  image: string;
  alt: string;
  eyebrow: string;
  label: string;
  link?: string;
};

export type MobileShowcaseItem = {
  id?: string;
  name: string;
  image: string;
  link?: string;
};

export type MobileShowcaseCard = {
  id: string;
  title: string;
  kicker: string;
  theme: string;
  seeMoreLink?: string;
  items: MobileShowcaseItem[];
};

export const mobileHeroBanners: MobileHeroBanner[] = [
  {
    id: 1,
    image: "/assets/images/banner/banner-1.jpg",
    alt: "Salar shopping banner",
    eyebrow: "SALAR SELECT",
    label: "Shopping picks for today",
    link: "/Categories",
  },
  {
    id: 2,
    image: "/assets/images/banner/banner-2.jpg",
    alt: "Salar electronics banner",
    eyebrow: "TECH DROP",
    label: "Upgrade your everyday",
    link: "/Categories/Electronics",
  },
  {
    id: 3,
    image: "/assets/images/banner/banner-3.jpg",
    alt: "Salar fashion banner",
    eyebrow: "STYLE EDIT",
    label: "Fresh looks, easy picks",
    link: "/Categories/Fashion",
  },
];

export const mobileShowcaseCards: MobileShowcaseCard[] = [
  {
    id: "continue",
    title: "Pick up where you left off",
    kicker: "CONTINUE SHOPPING",
    theme: "blue",
    seeMoreLink: "/Categories",
    items: [
      {
        name: "Samsung Galaxy S25 Ultra",
        image: "/assets/images/ban-pro/ban-pro-1.png",
        link: "/Categories",
      },
      {
        name: "Samsung Galaxy S25",
        image: "/assets/images/ban-pro/ban-pro-2.png",
        link: "/Categories",
      },
      {
        name: "iPhone 16",
        image: "/assets/images/ban-pro/ban-pro-3.png",
        link: "/Categories",
      },
      {
        name: "OnePlus 13",
        image: "/assets/images/ban-pro/ban-pro-4.png",
        link: "/Categories",
      },
    ],
  },
  {
    id: "women",
    title: "Keep shopping for",
    kicker: "YOUR RECENT INTERESTS",
    theme: "rose",
    seeMoreLink: "/todays-deals",
    items: [
      {
        name: "Women's Dresses",
        image: "/assets/images/ban-pro/ban-pro-5.png",
        link: "/Categories",
      },
      {
        name: "Fashion Lifestyle",
        image: "/assets/images/ban-pro/ban-pro-6.png",
        link: "/Categories",
      },
      {
        name: "Women's Tops",
        image: "/assets/images/ban-pro/ban-pro-7.png",
        link: "/Categories",
      },
      {
        name: "Lifestyle",
        image: "/assets/images/ban-pro/ban-pro-8.png",
        link: "/Categories",
      },
    ],
  },
  {
    id: "men",
    title: "Men's fashion deals",
    kicker: "TRENDING FOR YOU",
    theme: "sand",
    seeMoreLink: "/Categories/Men",
    items: [
      {
        name: "Printed Shirts",
        image: "/assets/images/ban-pro/ban-pro-9.png",
        link: "/Categories/Men",
      },
      {
        name: "Trending Shirts",
        image: "/assets/images/ban-pro/ban-pro-10.png",
        link: "/Categories/Men",
      },
      {
        name: "Check Shirts",
        image: "/assets/images/ban-pro/ban-pro-11.png",
        link: "/Categories/Men",
      },
      {
        name: "Formal Shirts",
        image: "/assets/images/ban-pro/ban-pro-12.png",
        link: "/Categories/Men",
      },
    ],
  },
  {
    id: "grocery",
    title: "Pantry deals up to 60% off",
    kicker: "GROCERY SAVINGS",
    theme: "mint",
    seeMoreLink: "/todays-deals",
    items: [
      {
        name: "Marie Lite",
        image: "/assets/images/ban-pro/ban-pro-13.png",
        link: "/todays-deals",
      },
      {
        name: "Tata Tea Gold",
        image: "/assets/images/ban-pro/ban-pro-14.png",
        link: "/todays-deals",
      },
      {
        name: "Vedaka Grains",
        image: "/assets/images/ban-pro/ban-pro-15.png",
        link: "/todays-deals",
      },
      {
        name: "Clove",
        image: "/assets/images/ban-pro/ban-pro-16.png",
        link: "/todays-deals",
      },
    ],
  },
  {
    id: "explore",
    title: "Explore something new",
    kicker: "DISCOVER ON SALAR",
    theme: "violet",
    seeMoreLink: "/Categories",
    items: [
      {
        name: "Mobiles & Accessories",
        image: "/assets/images/ban-pro/ban-pro-1.png",
        link: "/Categories",
      },
      {
        name: "Women Fashion",
        image: "/assets/images/ban-pro/ban-pro-18.png",
        link: "/Categories",
      },
      {
        name: "Men Fashion",
        image: "/assets/images/ban-pro/ban-pro-9.png",
        link: "/Categories/Men",
      },
      {
        name: "Home & Appliances",
        image: "/assets/images/ban-pro/ban-pro-17.png",
        link: "/Categories",
      },
    ],
  },
];
